import '../styles/TestTable.scss';

import React, { FC, PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FAILED, SUCCESS } from '../../../constants';
import { TestItem } from './TestItem';

const componentName = 'c-TestTable';

const TABS = {
  ALL: 'all',
  PASS: 'pass',
  FAIL: 'fail',
} as const;

const STATUS_BY_TAB = {
  [TABS.PASS]: [SUCCESS],
  [TABS.FAIL]: [FAILED],
} as const;

type TestTableProps = {
  className?: string;
};

interface TestTableWithItem extends FC<PropsWithChildren<TestTableProps>> {
  Item: typeof TestItem;
}

export const TestTable: TestTableWithItem = props => {
  const { children } = props;
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState('all');
  const { ALL, PASS, FAIL } = TABS;

  const tabs = [ALL, PASS, FAIL].map(label => (
    <div
      key={label}
      className={`${componentName}__title-item ${
        currentTab === label ? `${componentName}__active-label` : ''
      }`}
      onClick={() => setCurrentTab(label)}
      role="button"
      data-cy={`test-table-tab-${label.toLowerCase()}`}
      tabIndex={0}
    >
      {t(`componentTestTable_${label}`)}
    </div>
  ));

  const filteredChildren = React.Children.toArray(children).filter(child => {
    if (React.isValidElement<{ status?: string }>(child)) {
      return (
        STATUS_BY_TAB?.[currentTab]?.includes?.(child.props.status) ||
        currentTab === ALL
      );
    }
    return false;
  });

  return (
    <div className={componentName}>
      <div className={`${componentName}__table`}>
        <div className={`${componentName}__row`}>{tabs}</div>
        {filteredChildren}
      </div>
    </div>
  );
};

TestTable.Item = TestItem;
